export default __webpack_public_path__ + "static/media/hm-qt-img.aabb6e06.webp";